<div class="p-inputgroup">
  <input [id]="id" type="text"
         class="p-inputtext-sm"
         pInputText [(ngModel)]="formRecord"
         [required]="required===true"
         [disabled]="disabled===true"
         (change)="change?change():{}; this.formRecordChange.emit(this.formRecord)"
         [autocomplete]="'off'"
         [hidden]="hidden===true"
         (click)="showCronFieldDialog()"
  />
  <button type="button" pButton icon="pi pi-times" class="p-button-danger" (click)="clearValue()"></button>
</div>
<p-dialog [styleClass]="'cron-field-dialog'" [showHeader]="false" [modal]="true" [(visible)]="cronFieldDialogVisible"
          appendTo="body" position="top"
          [resizable]="false">
  <ng-template pTemplate="content">
    <span class="cron-field-dialog-content">
      <div class="p-field cron-input">
        <label for="cron-dialog-inpt">Cron selector</label>
        <input id="cron-dialog-inpt" pInputText [(ngModel)]="cronFieldDialogValue" class="w-100-pc"/>
      </div>
      <quartz-cron #cronField [(ngModel)]="cronFieldDialogValue" (ngModelChange)="valueChanged()"></quartz-cron>
    </span>
  </ng-template>
  <ng-template pTemplate="footer">
    <button pButton type="button" (click)="cronFieldDialogVisible=false;"
            [label]="'common.dialog.cancel' | translate"
            class="p-button-warning p-button-sm"></button>
    <button pButton type="button" (click)="saveCronFieldDialog()"
            [label]="'common.dialog.save' | translate"
            class="p-button-success p-button-sm"></button>
  </ng-template>
</p-dialog>
